import { render, staticRenderFns } from "./Number.vue?vue&type=template&id=53630fab&"
import script from "./Number.vue?vue&type=script&lang=js&"
export * from "./Number.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/T7/BACKUP/repositories/reveil-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53630fab')) {
      api.createRecord('53630fab', component.options)
    } else {
      api.reload('53630fab', component.options)
    }
    module.hot.accept("./Number.vue?vue&type=template&id=53630fab&", function () {
      api.rerender('53630fab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/Number.vue"
export default component.exports